import { Outlet } from 'react-router-dom';

const CampaignActionsLayout = () => {
  return <Outlet />;
};

export default CampaignActionsLayout;
